/**
 * BetaBadge component
 *
 * A specialized badge component for indicating beta features.
 * Extends the base Badge component with custom variants.
 */

import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { Badge } from "@shadcn/components/ui/badge"
import { cn } from "@shadcn/lib/utils"

const betaBadgeVariants = cva("", {
	variants: {
		variant: {
			regular: "", // Uses default badge styling
			large: "px-3 py-1 text-sm", // Size override
		},
	},
	defaultVariants: {
		variant: "regular",
	},
})

export interface BetaBadgeProps
	extends Omit<React.ComponentProps<typeof Badge>, "variant">,
		VariantProps<typeof betaBadgeVariants> {}

export function BetaBadge({ className, variant, children = "BETA", ...props }: BetaBadgeProps) {
	return (
		<Badge className={cn(betaBadgeVariants({ variant }), className)} {...props}>
			{children}
		</Badge>
	)
}

export { betaBadgeVariants }
